<template>
  <div class="yb-match-list column full-height relative-position match-tpl0">
    <!-- Header -->
    <div class="scroll-fixed-headerA">
      
      <div class="c-match-list-header yb-flex-between" :class="{ 'today-champion': (selectedBettype.betTypId == '6') }">
        <div class="col-left vrow items-center" v-if="searchLeague.lid>0">
          <div data-v-532cf2cd="" class="list-title vrow items-center">
            <div data-v-532cf2cd="" class="title-text yb-font-bold ellipsis"> {{ lang.sportTableLang['SPORT_TABLE.SEARCH_RESULTS'] }}</div>
            <span data-v-532cf2cd="" class="title-text path-icon-wrapper search">
              <span data-v-532cf2cd="" class="icon-triangle3 search-path-icon"></span>
              <span data-v-532cf2cd="">{{ searchLeague.lname }}</span>
            </span>
          </div>
        </div>
        <div class="col-left vrow items-center" v-else>
          <div class="btn-wrap match-btn yb-flex-center cursor-pointer" :class="{'active':!showFavEvents}" @click="changeMain" :style="specialEvent? 'margin-right: 10px;':''" v-if="!specialEvent">
            {{ lang.sportTableLang['SPORT_TABLE.ALL'] }}
          </div>
          <div :title="lang.sportTableLang['SPORT_TABLE.LBL_MY_FAVOURITE']" class="btn-wrap collect-btn yb-flex-center cursor-pointer" :class="{'active':showFavEvents}" @click="changeFavorite" v-if="!specialEvent">
            <i aria-hidden="true" role="presentation" class="q-icon icon-star c-icon set-color"
              :class="{ active: (countFav > 0) }" style="color: rgb(171, 186, 200); font-size: 14px;"> </i>
            <span class="number">
              {{ countFav }}
            </span>
          </div>
          <div class="list-title vrow items-center">
            <div class="title-text yb-font-bold ellipsis">
              <template v-if="selectedBettype.betTypId=='6'">
                {{ lang.configLang['CONFIG_LANG.LBL_GAME_OUTRIGHT'] }}
              </template> 
              <template v-else-if="(!showFavEvents && !open_RBMarket && !hotSchedule)">
                <template v-if="selectedMarket == market.inPlayMarket.key">
                  {{ lang.sportTableLang['SPORT_TABLE.HEADER_IN_PLAY_MARKET'] }}
                </template>
                <template v-else-if="selectedMarket == market.tdyMarket.key">
                  {{ lang.sportTableLang['SPORT_TABLE.HEADER_TODAY_MARKET'] }}
                </template>
                <template v-else>
                  {{ lang.sportTableLang['SPORT_TABLE.HEADER_EARLY_MARKET'] }}
                </template>

                <!-- <template v-if="subTitle == '' && selectedBettype.sprtTitleLang"> -->
                <template v-if="isGameBannerSelected && showGameBanner">
                  <template v-if="cookies_lang == 'zh_TW'">
                    ({{ gameBannerImage.bannerName_tw }})
                  </template>
                  <template v-else-if="cookies_lang == 'zh_CN'">
                    ({{ gameBannerImage.bannerName_cn }})
                  </template>
                  <template v-else>
                    ({{ gameBannerImage.bannerName_en }})
                  </template>
                </template>
                <template v-else-if="specialEvent">
                  ({{ lang.sportTableLang['SPORT_TABLE.SPECIAL_EVENT'] }})
                </template>
                <template v-else-if="selectedBettype.sprtTitleLang">
                  ({{ selectedBettype.sprtTitleLang }})
                </template>
              </template>
              <template v-else>
                <template v-if="open_RBMarket">
                  {{ lang.sportTableLang['SPORT_TABLE.HEADER_IN_PLAY_MARKET'] }}
                </template>
                <template v-if="hotSchedule">
                  {{ langList.hotSport }}
                </template>
              </template>
              <template v-if="selectedBettype.betTypId==5 && isParlayTab">
                 - {{ lang.configLang['CONFIG_LANG.LBL_BETTYPE_PARLAY'] }}
              </template>

            </div>
          </div>
        </div>
        <div class="col-right yb-flex-center"  v-if="searchLeague.lid==0">
          <div class="select-wrap relative-position">
            <!-- <div class="select-btn">
              <span class="fg1">近期开赛</span>
              <span class="fg2 mlr5">{{ lang.sportTableLang['SPORT_TABLE.SUBHEADER_SELECT_ALL_LEAGUE'] }}</span>
              <i size="14px" class="icon-arrow q-icon c-icon"></i>
            </div> -->
          </div>
          <div class="select-btn leagues-btn yb-flex-center cursor-pointer filter-handle yb-hover-bg m123" @click="toggleLeague($event)" v-if="!(isGameBannerSelected && showGameBanner) && !showFavEvents && !hotSchedule && !specialEvent">
            {{ lang.sportTableLang['SPORT_TABLE.SUBHEADER_SELECT_LEAGUE'] }}
            <span class="status yb-font-bold">
              <template v-if="arr_selectedLeagueList.length==0">
                {{ lang.sportTableLang['SPORT_TABLE.SUBHEADER_SELECT_ALL_LEAGUE'] }}
              </template>
              <template v-else>
                {{arr_selectedLeagueList.length}}
              </template>
            </span>
            <i size="14px" class="icon-arrow q-icon c-icon"></i>

            <!-- <template v-if="!selectedMatchAllBet">
              <div v-if="!account.previewFlag" class="lgselection_filter">
                <button class="filter icon-selectLeague" @click="toggleLeague($event)">
                  <template v-if="countCookieLeague()">
                    ({{ countLeagues(true) }})
                  </template>
                  <template v-else>
                    ({{ selectedLeagues }} / {{ totalLeagues }})
                  </template>
                  {{ lang.sportTableLang['SPORT_TABLE.LEAGUES'] }}
                </button>
              </div>
            </template> -->
          </div>
          <div show_type="sort" class="flex list-sort select-btn yb-hover-bg" v-if="selectedBettype.betTypId!=6  && !hotSchedule">
            <template v-for="sortType in sortTypes">
              <div class="list-sort-item"  :class="(sortType.key==selectedSort)?'active':''" @click="changeSort(sortType.key,$event) ">{{ lang.sportTableLang[sortType.lang] }}</div>
              <!--div class="content" :class="(sortType.key==1)?'icon-sortByTime':'icon-normalSorting'" @click="changeSort(sortType.key, $event)">{{ lang.sportTableLang[sortType.lang] }}</div-->
            </template>
          </div>
          <!-- <div class="select-btn refresh-btn yb-flex-center yb-hover-bg" @click="refreshTbl(token.arr_8)">
            <div class="c-refresh fit yb-flex-center cursor-pointer">
              <div class="icon-wrap">
                <span class="icon-balance_refresh">
                  <span class="path1"></span>
                  <span class="path2" style="position:absolute" :style="show_Fold?'right:79px;':'right:13px;'"></span>
                  <span class="path3" style="position:absolute" :style="show_Fold?'right:80px;':'right:14px;'"></span>
                </span>
              </div>
            </div>
          </div> -->
          <div class="refresh-icon-wrap yb-flex-center select-btn refresh-tbl-wrap yb-hover-bg" @click="refreshTbl(token.arr_8)">
            <div class="c-refresh fit yb-flex-center cursor-pointer refresh-btn">
              <div class="icon-wrap" id="tblRefresh">
                <i aria-hidden="true" role="presentation" class="q-icon icon-tbl_refresh c-icon" style="font-size: 18px;"></i>
              </div>
            </div>
          </div>
          <div class="unfold-btn" v-if="show_Fold" @click="foldSc()"> <!--sc only-->
            <span class="text">{{ lang.sportTableLang['SPORT_TABLE.OPEN'] }}</span>
            <i size="12px" class="icon-arrow q-icon c-icon"></i>
          </div>
        </div>
      </div>

      <!-- In-Play -->
      <template v-if="!showFavEvents && ((open_RBMarket && !hotSchedule) || selectedBettype.tmpltId == '11')">
        <div class="c-match-list-filter">
          <div class="drag-scroll relative-position  filter-sports"> <!--item-wrap-->
            <div class="hide-scrollbar" id="rb-sport-scroll">
              <div class="content" id="rb-scroll-content">
                <div class="item column yb-flex-center" :class="getActive(rbAllSport)" @click="selectRBSport(rbAllSport,false)">
                  <div class="icon-wrap list-filter">
                    <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px; background-position: 0px 0px;"></span>
                  </div>
                  <div class="name">{{ lang.sportTableLang['SPORT_TABLE.ALL'] }} {{ getCountAllSport() }} </div>
                </div>
                <!-- <div class="item column yb-flex-center" :class="simpleSport == sportList[0].sprtId? 'active':'no-active'" @click="selectRBSport(sportList[0],true)" v-if="selectedBettype.betTypId!='6'">
                  <div class="icon-wrap list-filter">
                    <span class="q-icon icon c-icon sport-img icon icon_simple_N1"></span>
                  </div>
                  <div class="name">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }} {{ countSport(sportList[0].sprtId) }} </div>
                </div> -->

                <template v-for="sport in sportList">
                  <template v-if="sport.sprtId == 'N1'">
                    <div class="item column yb-flex-center" :class="simpleSport == sportList[0].sprtId? 'active':'no-active'" @click="selectRBSport(sportList[0],true)" v-if="selectedBettype.betTypId!='6'">
                      <div class="icon-wrap list-filter">
                        <span class="q-icon icon c-icon sport-img icon icon_simple_N1"></span>
                      </div>
                      <div class="name">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }} {{ countSport('N1') }} </div>
                    </div>
                  </template>
                  <div class="item column yb-flex-center" :class="getActive(sport)" @click.prevent="selectRBSport(sport,false)" :style="countSport(sport.sprtId)==0?'display: none   ':''">
                    <div class="icon-wrap list-filter">
                      <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px;" :style="getBGPos(sport.sprtId)"></span>
                    </div>
                    <div class="name">{{sport.sprtLang}} {{ countSport(sport.sprtId) }} </div>
                  </div>
                </template>

                <div style="min-width: 84px;"></div>
                <div class="absolute-full resize-observer-wrap">
                  <div class="absolute-full expand"></div>
                  <div class="absolute-full shrink"></div>
                </div>
              </div>
            </div>
            <div class="more-btn left" v-show="showLarrowRB" @click="clickMove($event, 'left')"></div>
            <div class="more-btn right" v-show="showRarrowRB" @click=" clickMove($event, 'right')"></div>
          </div>

        </div>
      </template>

      <!-- Hot Sport -->
      <template v-if="!showFavEvents && hotSchedule">
        <div class="c-match-list-filter">
          <div class="drag-scroll relative-position  filter-sports"> <!--item-wrap-->
            <div class="hide-scrollbar" id="rb-sport-scroll">
              <div class="content" id="rb-scroll-content">
                <div class="item column yb-flex-center" :class="getActive(rbAllSport)" @click="selectRBSport(rbAllSport,false)">
                  <div class="icon-wrap list-filter">
                    <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px; background-position: 0px 0px;"></span>
                  </div>
                  <div class="name">{{ lang.sportTableLang['SPORT_TABLE.ALL'] }} </div>
                </div>
                <!--div class="item column yb-flex-center" :class="simpleSport == sportList[0].sprtId? 'active':'no-active'" @click="selectRBSport(sportList[0],true)" v-if="selectedBettype.betTypId!='6'">
                  <div class="icon-wrap list-filter">
                    <span class="q-icon icon c-icon sport-img icon icon_simple_N1"></span>
                  </div>
                  <div class="name">{{ lang.sportTableLang['SPORT_TABLE.SIMPLE_SOCCER'] }} {{ countSport(sportList[0].sprtId) }} </div>
                </div-->

                <template v-for="sport in hot_sportList">
                  <div class="item column yb-flex-center" :class="getActive(sport)" @click.prevent="selectRBSport(sport,false)">
                    <div class="icon-wrap list-filter">
                      <span class="q-icon icon c-icon sport-img icon" style="width: 20px; height: 20px;" :style="getBGPos(sport.sprtId)"></span>
                    </div>
                    <div class="name">{{sport.sprtLang}}</div>
                  </div>
                </template>

                <div style="min-width: 84px;"></div>
                <div class="absolute-full resize-observer-wrap">
                  <div class="absolute-full expand"></div>
                  <div class="absolute-full shrink"></div>
                </div>
              </div>
            </div>
            <div class="more-btn left" v-show="showLarrowRB" @click="clickMove($event, 'left')"></div>
            <div class="more-btn right" v-show="showRarrowRB" @click=" clickMove($event, 'right')"></div>
          </div>

        </div>
      </template>

      <!-- Early Date -->
      <template v-if="(selectedMarket==market.earlyMarket.key || (selectedBettype.betTypId=='5' && isParlayTab)) && selectedBettype.betTypId != '6'">
        <div class="c-match-list-filter date-filter early" v-if="!isGameBannerSelected && !specialEvent">
          <div class="tab-wrap fit relative-position" id="tabWrap">
            <div class="item-wrap relative-position" id="earlyDateScroll" :style="{'left':dateLeft+'px'}">
              <div :id="'tabDate-'+allDate" class="tab-item yb-flex-center" 
                  :class="{'active': allDate==selectedEarlyParlayDate }" 
                  @mouseover="highlightLine(allDate)" @mouseleave="highlightLine(selectedEarlyParlayDate)"
                  @click="changeEarlyParlayDate(allDate)">
                {{ lang.sportTableLang['SPORT_TABLE.ALL_DATES'] }}
                <span class="match-count"> ({{ totalCountByDate('ttl','all') }})</span>
              </div>
              <template v-for="(date, key) in earlyParlayDateList">
                <div :id="'tabDate-'+key" class="tab-item yb-flex-center" 
                    :class="{'active': key==selectedEarlyParlayDate}" 
                    @click="changeEarlyParlayDate(key)" 
                    @mouseover="highlightLine(key)" @mouseleave="highlightLine(selectedEarlyParlayDate)"
                    v-if="(selectedBettype.betTypId == '5' && isParlayTab && key =='0') || key!='0'">
                  <template v-if="selectedBettype.betTypId=='5' && key=='0'">
                    {{ date | date('MMMDo') }}
                  </template>
                  <template v-else>
                    <template v-if="selectedLang != '1'">
                      <template v-if="selectedLang == '6'">
                        {{ date | date('Do MMMM(ddd)') }}
                      </template>
                      <template v-else>
                        {{ date | date('MMMDo') }}
                      </template>
                    </template>
                    <template v-else>
                      {{ date | date('DD/MM') }}
                    </template>
                  </template>
                  <span class="match-count"> ({{ totalCountByDate(key) }})</span>
                </div>
              </template>
              <div :id="'tabDate-8'" class="tab-item yb-flex-center" 
                  :class="{'active': 8==selectedEarlyParlayDate}" 
                  @mouseover="highlightLine('8')" @mouseleave="highlightLine('8')"
                  @click="changeEarlyParlayDate(8)">
                {{ lang.sportTableLang['SPORT_TABLE.FUTURE'] }} 
                <span class="match-count"> ({{ totalCountByDate(8) }})</span>
              </div>
              <div class="line-wrap">
                <div class="line" id="earlyLine" style="width: 50px;"></div>
              </div>
            </div>
            <div class="left-btn btn" v-show="showLarrowEarly" @click="setDateArrow('L')">
              <div class="yb-icon-arrow"></div>
            </div>
            <div class="right-btn btn" v-show="showRarrowEarly" @click="setDateArrow('R')">
              <div class="yb-icon-arrow"></div>
            </div>
          </div>
        </div>
      </template> <!-- END Early Date Header -->
    </div>

    <!-- Content events -->
    <div class="load-data-wrap sport-table-scroll col">
      <div class="fit">
        <div class="v-scroll-list relative-position">
          <div class="list-scrollbar router_scroll_layout">
            <sportTemplate v-show="!reloading"></sportTemplate>
          </div>
        </div>
      </div>
    </div>

    <!-- content league select -->
    <leagueSelectionBox v-if="leagueToggle"></leagueSelectionBox>

    <!-- Loading -->
    <div class="refresh-mask absolute-full yb-flex-center" style="top: 36px;" v-show="reloading">
      <div class="img-loading custom-format-img-loading"></div>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
} from 'vuex'
import vueCookie from 'vue-cookie'
import EventBus from '../../events/event-bus'

import sportTemplate from './sportTemplate'
import leagueSelectionBox from './box/leagueSelectionBox'
import footerContent from './footerContent'
import allBetComponent from './allBet/all-bet'

import DateFilter from '../../filters/date'
import NumberFilter from '@/vue/filters/vue-filter-number'

import forecast from '@/vue/components/forecast'
import minibet from '@/vue/components/mini-bet'
import sportAllBet from '@/vue/mixins/allBet'
import sportMatchCount from '@/vue/mixins/sportMatchCount'

export default {
  mixins: [sportAllBet, sportMatchCount],
  components: {
    allBetComponent,
    sportTemplate,
    leagueSelectionBox,
    forecast,
    minibet,
    footerContent,
  },
  computed: {
    ...mapGetters([
      'account',
      'totalPage',
      'oddTypesList',
      'earlyParlayDateList',
      'sportTableLang',
      'market',
      'sortTypes',
      'sortShowTypes',
      'marketType',
      'selectedMarket',
      'selectedBettype',
      'selectedEarlyParlayDate',
      'selectedAllBet',
      'arr_selectedLeagueList',
      'favouriteEvents',
      'favouriteOTREvents',
      'favouriteOTREventsCount',
      'favouriteEventsCount',
      'favouriteRBEventsCount',
      'favouriteLgeEvents',
      'showFavEvents',
      'sportForecastToggle',
      'sportMiniBet',
      'cookieLeague',
      'selectedSport',
      'selectedMatchAllBet',
      'sortedMatchEventList',
      'langList',
      'open_RBMarket',
      'sportList',
      'allSportCount',
      'unfold_AllSc',
      'show_Fold',
      'showLeagueSearch',
      'searchLeague',
      // 'playTypeLang',
      'isParlayTab',
      'previousBettype',
      'isGameBannerSelected',
      'simpleSport',
      'hotSchedule',
      'hot_sportList',
      'specialEvent',
      'refreshToggle',
    ]),
    showFavEvents: {
      get() {
        return this.$store.getters.showFavEvents
      },
      set(value) {
        EventBus.$emit('refreshOdd', true)
        var dispatchName = 'getSportOdds'
        if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
          dispatchName = 'getSportOutrightOdds'
        }
        this.$store.dispatch(dispatchName, {
          showfavorite: value,
          callback: ((res) => {
            this.refreshTimer()
            this.refreshScroll()
          }).bind(this)
        })
      }
    },
    selectedPage: {
      get() {
        return this.$store.getters.selectedPage
      },
      set(value) {
        // this.reloadingPer = '0%';
        this.reloading = true
        EventBus.$emit('refreshOdd', true)
        this.$store.commit('SELECTED_PAGE', value)
        this.reloadTable(token.arr_13 + '|' + value)
      }
    },
    selectedSort: {
      get() {
        return this.$store.getters.selectedSort
      },
      set(value) {
        this.$store.commit('SELECTED_SORT', value)
      }
    },
    selectedShow: {
      get() {
        return this.$store.getters.selectedShow
      },
      set(value) {
        this.$store.commit('SELECTED_SHOW', value)
      }
    },
    selectedLeagues: {
      get() {
        return this.$store.getters.selectedLeagues
      },
      set(value) {
        // this.reloadingPer = '0%';
        this.reloading = true
        this.$store.commit('SELECTEDLEAGUES', value)
      }
    },
    totalLeagues: {
      get() {
        return this.$store.getters.totalLeagues
      },
      set(value) {
        this.$store.commit('TOTALLEAGUES', value)
      }
    },
    leagueToggle: function () {
      return this.$store.getters.bool_leagueToggle
    },
    countFav: function () {
      var count = 0
      var betTypId = this.selectedBettype.betTypId
      var sprtid = this.selectedBettype.sprtId
      if(betTypId==6){
          count = this.favouriteOTREventsCount
      }else{
        if (this.selectedMarket == '1' || this.selectedMarket == '5') {
          count = this.favouriteEventsCount +  this.favouriteRBEventsCount
        }else if (this.selectedMarket == '3') {
          count =  this.favouriteRBEventsCount
        }else{
          count =  this.favouriteEventsCount
        }
        /*
        if (this.favouriteLgeEvents[sprtid]) {
          count = this.favouriteLgeEvents[sprtid].length
        }
        if (this.favouriteEvents[sprtid]) {
          count = count + this.favouriteEvents[sprtid].length
        }*/
        
      }
      return count
    },
    onlyCommonAndNotParlayOTRTemplate() {
      var quickbet = ['1', '2', '3', '4', '5', '6', '7', '8']

      return (quickbet.includes(this.currentTemplate.id))
      // return (quickbet.includes(this.currentTemplate.id)) && this.$store.getters.selectedBettype.betTypId != '6'
      // return (this.currentTemplate.id == '1' || this.currentTemplate.id == '7'  || this.currentTemplate.id == '8') && this.$store.getters.selectedBettype.betTypId != '5'
    },
    onlyCommonAndNotParlayTemplate() {
      var quickbet = ['1', '2', '3', '4', '6', '7', '8']

      return (quickbet.includes(this.currentTemplate.id)) && this.$store.getters.selectedBettype.betTypId != '5'
    },
  },
  watch: {
    // 'showHideLRarrow': {
    //   handler(val, oldVal) {
    //     if(this.selectedMarket==this.market.earlyMarket.key ||  this.$store.getters.selectedBettype.betTypId == '5'){
    //       this.getDateStyle()
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    favouriteLgeEvents: {
      handler(val, oldVal) {
    //    console.log('favouriteLgeEventsval :'+val)
      },
      deep: true,
      immediate: true,
    },
    favouriteOTREventsCount: {
      handler(val, oldVal) {
    //   console.log('favouriteOTREventsListVal-- :'+val)
      },
      deep: true,
      immediate: true,
    },
    favouriteEventsCount: {
      handler(val, oldVal) {
  //      console.log('favouriteEventsListVal-- :'+val)
      },
      deep: true,
      immediate: true,
    },
    favouriteRBEventsCount: {
      handler(val, oldVal) {
    //    console.log('favouriteEventsListVal-- :'+val)
      },
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      hover: false,
      selectedOdd: null,
      lang: window.lang,
      timerSeconds: 60,
      earlyTimer: 60,
      rbTimer: 15,
      todayTimer: 30,
      reconnectTimerSeconds: 5,
      futureDate: '8',
      allDate: '99',
      todayDate: '0',
      selectedLang: window._langid,
      timerId: null,
      reconnectTimerId: null,
      reloading: false,
      oddsReload: false,
      currentTemplate: {},
      currentMarket: null,
      rbtable: false,
      normaltable: false,
      hoverDay: false,
      maxPayout: false,
      maxPayout_O: false,
      templateClass: "tableContent",
      templateClassArr: {
        "1": "FTR",
        "2": "FTPD",
        "3": "FTT",
        "4": "FTF",
        "8": "BKR",
        '6': 'FSFT',
      },
      subTitle: "",
      accountData: this.$store.getters.account,
      token: window.token,
      sortActive: false,
      showTypeActive: false,
      oddsTypeActive: false,
      marketActive: false,
      // reloadingPer: '0%',
      parlayST: ['N2', 'N1'],  //BK, SC
      parlayBT: ['1', '2', '3', '4', '7'],
      sportBettypeList: window.sportBettypeList,
      selRBSprtId: 'N1', 
      countAllSport: 0,
      rbAllSport: {
        "sprtId": "G98",
      },
      showLarrowEarly: false,
      showRarrowEarly: true,
      showLarrowRB: true,
      showRarrowRB: true,
      excludeLge: ['6'],
      dateLeft: 0,
      rbSportLeft: 0,
      showGameBanner: window._gameBanner? true:false,
      gameBannerImage: window._gameBannerImage,
      cookies_lang: window._cookie,
      cookies_lang: window._cookie,
      hotSport: window.hotSport,
      sport_profile: window.def_sport_profile,
    }
  },
  beforeMount() {
    this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
    if(this.selectedSport.sprtId == '' && this.selectedBettype.betTypId == ''){
      this.$store.commit('SPORTLIST', _.uniqBy(this.sportBettypeList,'sprtId'))
      this.$store.commit('SPORTBETTYPELIST', this.sportBettypeList)
      this.$store.commit('SELECTED_SPORT', this.$store.getters.sportList[0])
      this.commitBettypeList()
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(this.$store.getters.bettypeList[0]))
    }
    // this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180
    this.selectedOdd = this.$store.getters.account.oddsType
    this.startTimer()
    this.getSportSettings(token.arr_7)
    $('#AllBetab').getNiceScroll().remove();
    $('#AllBetab').remove();

    var favEvent_Arr = vueCookie.get(this.$store.getters.account.acccode+'_accfav_event')
    var favLgEvent_Arr = vueCookie.get(this.$store.getters.account.acccode+'_accfavlg_event')

    favEvent_Arr = JSON.parse(favEvent_Arr)
    favLgEvent_Arr = JSON.parse(favLgEvent_Arr)

    if(favEvent_Arr!=null && Object.keys(favEvent_Arr).length > 0){
      this.$store.commit('FAVOURITEEVENT_FIRSTLOAD')
    }
    if(favLgEvent_Arr!=null && Object.keys(favLgEvent_Arr).length > 0){
      this.$store.commit('FAVOURITELGEVENT_FIRSTLOAD')
    }
  },
  mounted() {
    var VUE = this
        
    this.$set(this.currentTemplate, 'id', _.cloneDeep(this.$store.getters.selectedBettype.tmpltId))
    this.currentMarket = this.$store.getters.selectedMarket

    EventBus.$on('lgreloading', (res)=> {
      this.reloading = res;
    })
    EventBus.$on('sportChange', ((params) => {
      this.rbtable= false,
      this.normaltable= false,
      this.$store.commit('SPORTFORECAST_TOGGLE', false)
      // this.cancelMiniBet()
      this.$store.commit('SORTEDEVENTLIST', []) //clear prev event
      EventBus.$emit('refreshOdd', true)
      this.$store.commit('SELECTED_PAGE', 1)
      if (params.tmpltId) {
        if (this.currentTemplate.id != params.tmpltId) {
          this.currentTemplate.id = params.tmpltId
        }
        this.reloading = true
        // TODO: reduce ajax call
        this.getSportSettings(token.arr_2)
      }
      if(this.$store.getters.selectedBettype.betTypId=='5'){
        var dtVal = (this.selectedMarket==this.$store.getters.market.earlyMarket.key) ? '99' : '0'
        this.setDateArrow('default')
        this.$nextTick(() => {
          this.highlightLine(dtVal);  //MULP default 'today date'/early default 'all'
        });
      }
    }).bind(this))
    EventBus.$on('inplaySportChange', ((params) => {
      // this.$store.commit('SPORTFORECAST_TOGGLE', false)
      // this.cancelMiniBet()

      EventBus.$emit('refreshOdd', true )
      this.getSportSettings(token.arr_2)
      // this.$store.commit('SELECTED_PAGE', 1)
      // if(params.tmpltId){
      //   if(this.currentTemplate.id != params.tmpltId) {
      //     this.currentTemplate.id = params.tmpltId
      //   }
      //   // TODO: reduce ajax call
      //   this.getSportSettings(token.arr_2)
      // }
    }).bind(this))
    EventBus.$on('pageChange', ((params) => {
      this.$store.commit('SPORTFORECAST_TOGGLE', false)
      this.cancelMiniBet()
      this.$store.commit('SELECTED_PAGE', 1)

      // this.reloadingPer = '0%';
      this.reloading = true
      this.$store.dispatch('getLaugueList', {
        callback: ((res) => {
          this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
          this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
          this.reloading = false
        }).bind(this)
      })

      if (this.leagueToggle === true) {
        this.toggleLeague()
      }
    }).bind(this))
    EventBus.$on('marketChange', ((params) => {
      this.maxPayout = false
      this.maxPayout_O = false
      this.$store.commit('SPORTFORECAST_TOGGLE', false)
      this.$store.commit('SORTEDEVENTLIST', []) //clear prev event
      // this.cancelMiniBet()
      if (this.selectedMarket == '1' && this.$store.getters.selectedBettype.betTypId != '5') {
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.todayDate)
      } else {
        this.$store.commit('SELECTEDEARLYPARLAYDATE', this.allDate)
      }
      this.$store.commit('SELECTED_PAGE', 1)
      this.currentMarket = params
      this.computeSubTitle()
      if(this.$store.getters.selectedMarket != 5){
        if (this.currentTemplate.id != this.$store.getters.selectedBettype.tmpltId) {
          this.getSportSettings()
          this.$set(this.currentTemplate, 'id', _.cloneDeep(this.$store.getters.selectedBettype.tmpltId))
        } else {
          // this.reloadingPer = '0%';
          this.reloading = true
          this.getLeagueList()
        }
      }
      if (this.leagueToggle === true) {
        this.toggleLeague()
      }

      if((this.selectedMarket==this.$store.getters.market.earlyMarket.key||this.$store.getters.selectedBettype.betTypId=='5') && this.$store.getters.selectedBettype.betTypId != '6' && !(this.isGameBannerSelected && this.showGameBanner)){
        this.setDateArrow('default')
        this.$nextTick(() => {
          this.highlightLine(this.allDate);
        });
      }

    }).bind(this))
    EventBus.$on('sportTableReloading', ((params) => {
      // this.reloadingPer = '75%';
      this.reloading = params
    }).bind(this))

    EventBus.$on('selectLeagueRefreshTable', ((params) => {
      // console.log(params)
        this.refreshTbl(params.token);
    }).bind(this))

    EventBus.$on('changemain', ((params) => {

      this.changeMain()
    }).bind(this))

    EventBus.$on('sportSelectedAllBetChange', ((params) => {
      this.$nextTick(() => {
        if (this.$store.getters.selectedBettype.betTypId == '5') {
          _.forEach(this.$store.getters.betForm, function (value, key) {
            if (VUE.selectedAllBet) {
              $('.' + value.uniqueId).closest('td').addClass('bg_yellow')
            } else {
              $('.' + value.uniqueId).closest('td').addClass('highlightedP')
            }
          })
        }
      })
    }).bind(this))
    EventBus.$on('getSpecialEvent', ((params) => {
      this.$store.commit('SPORTFORECAST_TOGGLE', false)
      this.$store.commit('SORTEDEVENTLIST', []) //clear prev event
      EventBus.$emit('refreshOdd', true)
      this.$store.commit('SELECTED_PAGE', 1)
      this.reloadTable()
    }).bind(this))
  },
  beforeUpdate() {
    this.refreshScroll()
  },
  updated() {
    if(!this.reloading) {
      this.updateHightlightOdds()
    }
  },
  destroyed() {
    this.clearTimer()
    EventBus.$off('lgreloading')
    EventBus.$off('sportChange')
    EventBus.$off('inplaySportChange')
    EventBus.$off('pageChange')
    EventBus.$off('marketChange')
    EventBus.$off('sportTableReloading')
    EventBus.$off('selectLeagueRefreshTable')
    EventBus.$off('chamgemain')
    EventBus.$off('sportSelectedAllBetChange')
    EventBus.$off('refreshOdd')
    EventBus.$off('viewAccountSetting')
    EventBus.$off('getSpecialEvent')
  },
  methods: {
    highlightLine(val){
      this.$nextTick(() => {
        var position = $("#tabDate-"+val).first().position();
        if(position) {
          var center =  position.left + $("#tabDate-"+val).outerWidth()/2 - 25;
          $('.c-match-list-filter .line').css('transform','translateX('+ center +'px)')
        }
      })
    },
    foldSc(){
      this.$store.commit('SHOW_UNFOLD', true)
      this.$store.commit('SHOW_FOLD', false)
      this.$store.commit('UNFOLD_ALLSC', false)
      var temp = this.$store.getters.selectedBettype
      var element = document.getElementById('AllBetScrollfirstEvent');
      element.classList.remove('hide');
      this.$store.commit('SELECTED_BETTYPE', _.cloneDeep(temp))
    },
    setDateArrow(direction){  //early date left right arrow
      if(direction=='default'){
        this.dateLeft = 0
        this.showLarrowEarly = false
        this.showRarrowEarly = true
        return
      }
      this.dateLeft += (direction=='R') ? -100 : 100

      var totalWidth = 0
      var holderWidth = $('#tabWrap').width()
      this.showLarrowEarly = (this.dateLeft<0) ? true : false

      $("#earlyDateScroll > .tab-item").each(function() {
        totalWidth = totalWidth + $(this).outerWidth();
      });
      var calc = totalWidth + this.dateLeft
      this.showRarrowEarly = (calc>holderWidth) ? true : false
    },
    clickMove(e, direction){
      var VUE = this
      var holderWidth = $('#rb-sport-scroll').width()
      var totalWidth = 0
      var count = 0
      $("#rb-scroll-content > .item.column").each(function() {
        totalWidth = totalWidth + $(this).outerWidth();
      });
      
      var setI = setInterval(function () {
        count++
        if(count > 12){
          clearInterval(setI)
        }

        VUE.rbSportLeft += (direction=='right') ? 15 : -15
        document.getElementById("rb-sport-scroll").scrollLeft = VUE.rbSportLeft

        var calc = totalWidth - VUE.rbSportLeft
        VUE.showLarrowRB = (VUE.rbSportLeft>0) ? true : false
        VUE.showRarrowRB = (calc>holderWidth) ? true : false
      }, 16);
    },
    getCountAllSport(){
      var Vue = this
      var count = []
      if(this.selectedMarket == 3){
        $.each(Vue.allSportCount['live'], function(sport, bettype){if(sport.charAt(0)=='N'){
          $.each(bettype, function(key, val){
              if(key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11'){
                count.push(val)
                  // counter = counter + val
              }else  if(key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11'){
                count.push(val)
              }
            })
          }
        })
      }else{
        // var mrk = (this.selectedMarket==1)?'today':'early'
        $.each(Vue.allSportCount['today'], function(sport, bettype){
          if(sport.charAt(0)=='N'){
            $.each(bettype, function(key, val){
                if(key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11'){
                  count.push(val)
                    // counter = counter + val
                }else  if(key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11'){
                  count.push(val)
                }
            })
          }
        })
        $.each(Vue.allSportCount['early'], function(sport, bettype){
          if(sport.charAt(0)=='N'){
            $.each(bettype, function(key, val){
                if(key == 'RAH' && Vue.$store.getters.selectedBettype.tmpltId != '11'){
                  count.push(val)
                    // counter = counter + val
                }else  if(key == 'OTR' && Vue.$store.getters.selectedBettype.tmpltId == '11'){
                  count.push(val)
                }
            })
          }
        })
      }
      return _.sum(count)
    },
    countSport(sprtId){
      var Vue = this
      var count = []
      var counter = 0
      if(Vue.$store.getters.selectedBettype.tmpltId == '11'){
        $.each(Vue.allSportCount['early'], function(sport, bettype){
          if(sprtId == sport){
            count.push(bettype['OTR'])
          }else if(sprtId == 'G1' && sport == 'Basketball'){
            count.push(bettype['OTR'])
          }else if(sprtId == 'G2' && sport == 'Others'){
            count.push(bettype['OTR'])
          }
        })
      }else{
        $.each(Vue.allSportCount['live'], function(sport, bettype){
          if(sprtId == sport){
            count.push(bettype['RAH'])
          }else if(sprtId == 'G1' && sport == 'Basketball'){
            count.push(bettype['RAH'])
          }else if(sprtId == 'G2' && sport == 'Others'){
            count.push(bettype['RAH'])
          }
        })
      }
      if(_.isUndefined(_.sum(count))){
        return 0;
      }
      // console.log(sport +' == '+_.sum(count))
      return _.sum(count)
    },
    selectRBSport(sport, simpleSport=false){
      if(simpleSport){
          this.$store.commit('SIMPLE_SPORT', sport.sprtId)
      } else {
          this.$store.commit('SIMPLE_SPORT', null)
      }
      var sprtData = sport  //prevent set value using sport param (getters)
      if(this.$store.getters.selectedBettype.tmpltId == '11'){
        this.selRBSprtId = (sprtData.sprtId==this.rbAllSport.sprtId) ? this.rbAllSport.sprtId : sprtData.sprtId
        var arr = _.cloneDeep(this.$store.getters.otrBetType)
        arr.sprtId = this.selRBSprtId
        this.$store.commit('SELECTED_BETTYPE',  arr)
        this.$store.commit('SELECTED_SPORT', arr)
        this.$store.dispatch('getSportOutrightOdds', {
          callback: ((res) => {
            EventBus.$emit('refreshOdd', true)
          }).bind(this)
        })
      }else{
        this.selRBSprtId = (sport.sprtId==this.rbAllSport.sprtId) ? this.rbAllSport.sprtId : sport.sprtId
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
        this.$store.commit('SELECTED_ALLBET', false)
        this.$store.commit('SELECTED_MATCHALLBET', false)
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
        if(sport.sprtId!='N1'){
          this.$store.commit('SHOW_UNFOLD', false)
        }else{
          if(!_.isUndefined(this.unfold_AllSc[sport.sprtId]) && !_.isUndefined(this.unfold_AllSc[sport.sprtId][sport.betTypId])){
            if(!this.unfold_AllSc[sport.sprtId][sport.betTypId]){
              this.$store.commit('SHOW_UNFOLD', true)
            }
          }
        }
        EventBus.$emit('refreshOdd', true);
        EventBus.$emit('viewAccountSetting', false)
        this.$store.commit('SELECTED_SPORT', sport)
        this.commitBettypeList()
        this.$store.commit('SELECTED_BETTYPE',this.$store.getters.bettypeList[0])
        // this.$store.commit('SELECTED_INPLAYSPORT', sport)
        EventBus.$emit('inplaySportChange', sport );
        EventBus.$emit('viewAccountSetting', false)
        this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('SELECTED_ALLBET', false)
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
        this.$store.commit('SELECTED_MATCHALLBET', false)
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
        this.$store.commit('SORTEDRBEVENTLIST', [])
        this.$store.commit('RBEVENTLIST', [])
        this.$store.commit('SPORTFORECAST_LIST', null)  
        if(this.$store.getters.hotSchedule == false){
          this.$store.commit('OPEN_RBMARKET', true)
        }
        // this.resetSportBettype()
        EventBus.$emit('refreshOdd', true );
        EventBus.$emit('marketChange', this.$store.getters.market.inPlayMarket.key );
      }
      if(this.selectedBettype.betTypId != 5){
        this.$store.commit("IS_BETPARLAY", false);
      }
    },
    commitBettypeList() {
      if(this.$store.getters.selectedSport.sprtId == 'G98'){
                this.$store.commit('BETTYPELIST',
                    _.filter(
                        this.sportBettypeList,
                        {
                            'sprtId' : 'N1'
                        }
                    )
                )
            }else{
                this.$store.commit('BETTYPELIST',
                    _.filter(
                        this.sportBettypeList,
                        {
                            'sprtId' : this.$store.getters.selectedSport.sprtId
                        }
                    )
                )
            }
        },
    getActive(sport){
      var str = 'no-active'
      var str2 = (sport.sprtId == this.rbAllSport.sprtId) ? '' : '' 
      // var str2 = (sport.sprtId == this.rbAllSport.sprtId) ? '' : ' sprtNoEve' // hide if sport no match
      this.selRBSprtId = this.$store.getters.selectedSport.sprtId
      if(((this.selRBSprtId == this.rbAllSport.sprtId && this.selRBSprtId != sport.sprtId) || this.selRBSprtId == sport.sprtId) && this.$store.getters.simpleSport == null){
        str = 'active'
      }

      $.each(this.allSportCount['live'], function(sportLang, bettype){
        if(sport.sprtId==sportLang  && bettype['RAH'] > 0){
          str2 = ''
        }else if(sport.sprtId == 'G1' && sportLang == 'Basketball' && bettype['RAH'] > 0){
          str2 = ''
        }else if(sport.sprtId == 'G2' && sportLang == 'Others' && bettype['RAH'] > 0){
          str2 = ''
        }
      })

      return str + str2
    },
    getBGPos(sprtId){
      var a = ''
      if(sprtId=='N1'){         //Soccer
        a = 'background-position: 0px -28.33px;'
      }else if(sprtId=='G1' || sprtId=='N2'){   //BK
        a = 'background-position: 0px -85px;'
      }else if(sprtId=='N3'){   //Tennis
        a = 'background-position: 0px -538.33px;'
      }else if(sprtId=='N21'){   //Volley
        a = 'background-position: 0px -170px;'
      }else if(sprtId=='N12'){  //Badminton
        a = 'background-position: 0px -623.33px;'
      }else if(sprtId=='N15'){  //Snooker
        a = 'background-position: 0px -425px;'
      }else if(sprtId=='G2'){
        a = ''
      }else if(sprtId=='N7'){  //cricket
        a = 'background-position: 0px -1445px;'
      }else if(sprtId=='N14'){  //ice hockey
        a = 'background-position: 0px -57px;'
      }else if(sprtId=='N13'){  //Am fooball
        a = 'background-position: 0px -114px;'
      }else if(sprtId=='N19'){  //handball
        a = 'background-position: 0px -368.5px;'
      }else if(sprtId=='N20'){  //Esport
        a = 'background-position: 0px -142px;'
      }else if(sprtId=='N23'){  //Baseball
        a = 'background-position: 0px -793px;'
      }else{
        a = 'background-position: 0px -85px;'
      }
      return a
    },
    getMarketTimer(selMarket) {
      if (this.$store.getters.open_RBMarket) {
        return this.rbTimer
      } else if (selMarket == this.$store.getters.market.earlyMarket.key) {
        return this.earlyTimer
      } else if (selMarket == this.$store.getters.market.tdyMarket.key) {
        return this.todayTimer
      }
    },
    deactiveDropDown() {
      if (this.oddsTypeActive) {
        this.oddsTypeActive = false
      }
      if (this.sortActive) {
        this.sortActive = false
      }
      if (this.marketActive) {
        this.marketActive = false
      }
      if (this.showTypeActive) {
        this.showTypeActive = false
      }
    },
    sportTitle() {
      if (this.$store.getters.selectedSport.sprtId == 'N1') {
        return 'sport1'
      } else if (this.$store.getters.selectedSport.sprtId == 'G1') {
        return 'sport2'
      } else if (this.$store.getters.selectedSport.sprtId == 'N3') {
        return 'sport5'
      } else if (this.$store.getters.selectedSport.sprtId == 'N21') {
        return 'sport6'
      } else if (this.$store.getters.selectedSport.sprtId == 'N15') {
        return 'sport7'
      } else if (this.$store.getters.selectedSport.sprtId == 'N12') {
        return 'sport9'
      } else {
        return 'sport99'
      }
    },
    backToMain() {
      EventBus.$emit('sportTableReloading', true)
      this.reloadTable()
      this.$store.commit('SELECTED_MATCHALLBET', false)
    },
    oddsTypeClass(key) {
      if (key == 'my') {
        return 'icon-malayOdds'
      } else if (key == 'hk') {
        return 'icon-hongKongOdds'
      } else if (key == 'in') {
        return 'icon-indonesianOdds'
      } else if (key == 'eu') {
        return 'icon-decimalOdds'
      } else if (key == 'am') {
        return 'icon-americanOdds'
      }
    },
    showTypeClass(key) {
      if (key == '1') {
        return 'icon-singleLine'
      } else if (key == '2') {
        return 'icon-doubleLine'
      } else if (key == '3') {
        return 'icon-fullTimes'
      } else if (key == '4') {
        return 'icon-halfTime'
      }
    },
    marketTypeClass(key) {
      if (key == '1') {
        return 'icon-allMarkets'
      } else if (key == '2') {
        return 'icon-mainMarkets'
      } else if (key == '3') {
        return 'icon-otherMarkets'
      }
    },
    cancelMiniBet() {
      var sportMiniBet = this.$store.getters.sportMiniBet
      sportMiniBet.toggle = false
      this.$store.commit('SPORT_MINIBET', sportMiniBet)
    },
    countCookieLeague(countLeague = null) {
      var selectedMarket = this.$store.getters.selectedMarket
      var selectedSport = this.$store.getters.selectedBettype.sprtId
      var selectedBettype = this.$store.getters.selectedBettype.betTypId
      if (this.$store.getters.isGameBannerSelected) {
        selectedBettype += 'gmBanner'
      }
      //check cookieleague valid or not
      if (this.cookieLeague) {
        if (this.cookieLeague[selectedMarket]) {
          if (this.cookieLeague[selectedMarket][selectedSport]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
              if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
                if (countLeague) {
                  return this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length
                }
                return true
              }
            }
          }
        }
      }
      return false

    },
    countLeagues(countLeague = null) {
      var selectedMarket = this.$store.getters.selectedMarket
      var selectedSport = this.$store.getters.selectedBettype.sprtId
      var selectedBettype = this.$store.getters.selectedBettype.betTypId
      var totalLeagues = ''
      if (this.$store.getters.isGameBannerSelected) {
        selectedBettype += 'gmBanner'
      }
      //check cookieleague valid or not
      if (this.cookieLeague) {
        if (this.cookieLeague[selectedMarket]) {
          if (this.cookieLeague[selectedMarket][selectedSport]) {
            if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype]) {
              if (this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length > 0) {
                if (countLeague) {

                  if (this.$store.getters.arr_leagueList != null) {
                    totalLeagues = Object.keys(this.$store.getters.arr_leagueList).length
                  }

                  return this.cookieLeague[selectedMarket][selectedSport][selectedBettype].length + ' / ' + totalLeagues
                }
                return true
              }
            }
          }
        }
      }
      return false

    },
    checkMinibet(windowEvent) {
      this.toggleActive()
      var sportMiniBet = this.$store.getters.sportMiniBet
      sportMiniBet.allow = !this.$store.getters.sportMiniBet.allow
      this.$store.commit('SPORT_MINIBET', sportMiniBet)
      if (!sportMiniBet.allow) {
        this.$store.commit('SPORT_MINIBET_TOGGLE', false)
      }
    },
    clearFavourite() {
      this.$store.commit('FAVOURITEEVENT', { clear: true })
      if (!this.$store.getters.showFavEvents) {
        var dispatchName = 'getSportOdds'
        if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
          dispatchName = 'getSportOutrightOdds'
        }
        this.$store.dispatch(dispatchName, {
          callback: ((res) => {
            EventBus.$emit('refreshOdd', true)
          }).bind(this)
        })
      }
    },
    changeFavorite() {
      if(this.countFav != 0 && (Object.keys(this.favouriteLgeEvents).length > 0 || Object.keys(this.favouriteEvents).length > 0 || Object.keys(this.favouriteOTREvents).length > 0) ){
        this.showFavEvents = true
        this.$store.commit('SPORT_SHOW_FAV_EVENTS', true)
        EventBus.$emit('viewAccountSetting', false)
        // this.$store.commit("GAMEBANNER_SELECTED", false);
        this.$store.commit('SELECTED_ALLBET', false)
        this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
        this.$store.commit('SELECTED_MATCHALLBET', false)
        // this.resetSportBettype()
        EventBus.$emit('refreshOdd', true);

        EventBus.$emit('pageChange', this.$store.getters.market.favMarket.key);
      }
    },
    changeMain() {
      this.showFavEvents = false
      this.$store.commit('SPORT_SHOW_FAV_EVENTS', false)
      EventBus.$emit('viewAccountSetting', false)
      // this.$store.commit("GAMEBANNER_SELECTED", false);
      this.$store.commit('SELECTED_ALLBET', false)
      this.$store.commit('STATEMENT_SHOW_STATEMENT', false)
      this.$store.commit('SELECTED_MATCHALLBET', false)
      // this.resetSportBettype()
      EventBus.$emit('selectLeagueRefreshTable', token.arr_4);
      EventBus.$emit('refreshOdd', true);
      
      EventBus.$emit('pageChange', this.$store.getters.selectedMarket);
    },
    changeTime(event) {
      this.$store.commit('SPORT_FULLHALF_TIME', event.target.value)
      this.reloadTable();
    },
    toggleLeague(windowEvent = null) {
      this.$store.commit('MERGE_LEAGUELIST', null)
      this.reloading = true
      this.toggleActive()
      this.$store.commit('SPORT_MINIBET_TOGGLE', false)
      // this.$store.commit('SPORT_LEAGUE_TOGGLE')
      this.$store.commit('SORTEDEVENTLIST', []) //clear prev event
      this.$store.commit('SORTEDRBEVENTLIST', []) //clear prev rb event
      this.$store.dispatch('toggleSportLeague', {
        callback: ((res) => {

          EventBus.$emit('setLeagueList', res)
        }).bind(this)
      })

      if (windowEvent != null) {
        this.$store.commit('SPORTLEAGUE_WINDOWEVENT', windowEvent)
      }
    },
    toggleActive() {
      this.sortActive = false
      this.showTypeActive = false
      this.oddsTypeActive = false
      this.marketActive = false
    },
    clickSort(types) {
      this.toggleActive()
      if (types == 'showType') {
        this.showTypeActive = (this.showTypeActive) ? false : true;
      } else if (types == 'sortGame') {
        this.sortActive = (this.sortActive) ? false : true;
      } else if (types == 'oddsType') {
        this.oddsTypeActive = (this.oddsTypeActive) ? false : true;
      } else if (types == 'showMarket') {
        this.marketActive = (this.marketActive) ? false : true;
      }
    },
    changeSort(sortkey, event) {
      // this.reloadingPer = '0%';
      this.reloading = true
      event.preventDefault()
      event.stopPropagation()
      this.sortActive = false

      this.$store.commit('SELECTED_SORT', sortkey)
      this.$store.commit('SHOW_UP_DOWN', false)
      EventBus.$emit('refreshOdd', true)
      this.refreshTbl(token.arr_17)
      // this.reloadTable(token.arr_17)

      // if(!this.$store.getters.open_RBMarket && this.$store.getters.selectedMarket==this.market.tdyMarket.key 
      // && !this.excludeLge.includes(this.$store.getters.selectedBettype.betTypId)){
      //   this.reloadRBTable(token.arr_17)
      // }
    },
    changeShow(showkey, event) {
      // this.reloadingPer = '0%';
      this.reloading = true
      event.preventDefault()
      event.stopPropagation()
      this.showTypeActive = false

      this.$store.commit('SELECTED_SHOW', showkey)
      EventBus.$emit('refreshOdd', true)

      if (this.selectedMatchAllBet) {
        // this.reloadingPer = '50%';
        this.$store.dispatch('getMatchAllBet', {
          event: this.sortedMatchEventList,
          token: token.arr_4,
          callback: ((res) => {
            this.reloading = false
            this.oddsReload = false
            this.refreshScroll()
          }).bind(this)
        })

      } else {
        this.reloadTable(token.arr_17)
      }
    },
    changeMarket(marketkey) {
      this.$store.commit('SELECTED_MARKET', marketkey)

      EventBus.$emit('refreshOdd', true)
      this.reloadTable(token.arr_17)
    },
    changeOdd(orderkey, event) {
      // this.reloadingPer = '0%';
      this.reloading = true
      event.preventDefault()
      event.stopPropagation()

      this.oddsTypeActive = false
      this.selectedOdd = orderkey
      this.$store.commit('SELECTED_ODD', orderkey)
      //  this.$store.commit('CHANGE_ODDS', true)
      EventBus.$emit('cancelBetForm');
      EventBus.$emit('REMOVE_ALL_FORECAST');

      if (this.selectedMatchAllBet) {
        // this.reloadingPer = '50%';
        this.$store.dispatch('getMatchAllBet', {
          event: this.sortedMatchEventList,
          token: token.arr_4,
          callback: ((res) => {
            this.reloading = false
            this.oddsReload = false
            this.refreshScroll()
          }).bind(this)
        })

      } else {
        this.reloadTable(token.arr_4)
      }
    },
    changeEarlyParlayDate(dateKey) {
      this.$store.commit('SORTEDRBEVENTLIST', [])
      EventBus.$emit('refreshOdd', true);
      // this.reloadingPer = '0%';
      this.reloading = true
      this.$store.commit('SELECTED_PAGE', 1)
      this.$store.commit('SELECTEDEARLYPARLAYDATE', dateKey)
      this.reloadTable()
    },
    refreshTbl(token_val) {
      if(!this.refreshToggle) {
        $('#tblRefresh').addClass('loading-static-animation')

        this.reloading = (token_val == token.arr_1 || token_val == token.arr_5) ? false : true
        if (this.selectedMatchAllBet) {
          this.reloadAllBetTable(token_val)
        } else {
          this.reloadTable(token_val)

          // refresh today market RB matches
          // if(!this.$store.getters.open_RBMarket && this.$store.getters.selectedMarket==this.market.tdyMarket.key 
          // && (!this.excludeLge.includes(this.$store.getters.selectedBettype.betTypId) || (this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab)) && !this.showFavEvents){
          //   this.reloadRBTable(token_val)
          // }
        }
      }
    },
    reloadAllBetTable(token_val = '') {
      if (token_val == '') {
        token_val = token.arr_5
      }
      // this.reloadingPer = '25%';
      this.cloneEventAllBet = _.cloneDeep(this.$store.getters.sortedMatchEventList)

      // this.reloadingPer = '80%';
      this.$store.dispatch('getSportAllBet', {
        token: token_val,
        inAllBet: true,
        event: this.$store.getters.sortedMatchEventList,
        callback: ((res) => {
          this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

          this.startTimer()
          this.mainMarketList = _.cloneDeep(this.$store.getters.sortedMatchEventList)

          this.$nextTick(() => {
            EventBus.$emit('diffOdd', this.cloneEventAllBet)
          })
          this.reloading = false
          $('#tblRefresh').removeClass('loading-static-animation')
        }).bind(this)
      })
    },
    reloadTable(token_val = '') {
      this.$store.commit('REFRESHTOGGLE', true)
      this.oddsReload = true
      this.clearTimer()
      EventBus.$emit('templateChange', this.oddsReload);
      // this.reloadingPer = '25%';
      var dispatchName = 'getSportOdds'

      if(!this.$store.getters.open_RBMarket && ( this.$store.getters.selectedMarket==this.market.hotSportMarket.key || this.$store.getters.selectedMarket==this.market.tdyMarket.key) && !this.excludeLge.includes(this.$store.getters.selectedBettype.betTypId) && !this.showFavEvents){
        if(this.$store.getters.isParlayTab && (!window.allowRbParlay || (this.$store.getters.selectedEarlyParlayDate != 99 && this.$store.getters.selectedEarlyParlayDate != 0))){
          this.$store.commit('SORTEDRBEVENTLIST', [])
          dispatchName = 'getSportOdds'
        }else{
          dispatchName = 'getRbTodayOdds'
        }
      }

      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        dispatchName = 'getSportOutrightOdds'
      }
      if(this.$store.getters.specialEvent) {
        dispatchName = 'getSpecialEventOdds'
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8
      }
      // this.reloadingPer = '80%';
      this.$store.dispatch(dispatchName, {
        token: token_val,
        showfavorite: (this.$store.getters.showFavEvents && dispatchName == 'getSportOdds')? true:false,
        callback: ((res) => {
          if (res.events || res.events_rb) {
            // this.$store.commit('CHANGE_ODDS', false)
            this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)

            this.startTimer()
            clearInterval(this.reconnectTimerId)
            this.reconnectTimerId = null
            // _.forEach(res.events, function (val, key) {
            //   _.forEach(val, function (v, k) {
                // var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse')
                // if (showAllBet) {
                  // $('#moreExpand' + v.eveid).addClass('icon-moreExpand')
                  // $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse')
                  // $('#moreBets' + v.eveid).css("display", "none");
                // }
              // })
            // })
            this.normaltable = res.events ? true : false;
            this.rbtable = res.events_rb ? true : false;
          } else {
            this.reconnectTimerSeconds = 5;
            if (this.reconnectTimerId == null) {
              this.reconnectTimerId = setInterval(() => {
                if (this.reconnectTimerSeconds - 1 < 0) {
                  this.reloadTable()
                } else {
                  this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          if (this.showFavEvents) {
            this.$store.dispatch('getLaugueList', {
              callback: ((res) => {
                this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
                this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
              }).bind(this)
            })
          }
          if(this.$store.getters.selectedMarket == 1 && this.$store.getters.selectedBettype.betTypId != '6' && this.$store.getters.selectedBettype.betTypId != '5'){
            // if(this.normaltable == true && this.rbtable == true){
              this.reloading = false
              this.oddsReload = false
              EventBus.$emit('templateChange', this.oddsReload);
              this.refreshScroll()

              this.$store.commit('PARLAY_SELECTED', { update: false })
            // }
          }else{
            this.reloading = false
            this.oddsReload = false
            EventBus.$emit('templateChange', this.oddsReload);
            this.refreshScroll()

            this.$store.commit('PARLAY_SELECTED', { update: false })
          }
          $('#tblRefresh').removeClass('loading-static-animation')
          this.$store.commit('REFRESHTOGGLE', false)
        }).bind(this)
      })
    },
    reloadRBTable(token_val = '') {
      //reload RB matches in today market
      this.oddsReload = true
      this.clearTimer()
      EventBus.$emit('templateChange', this.oddsReload);
      // this.reloadingPer = '25%';
      var dispatchName = 'getSportOdds'
      if (this.$store.getters.selectedBettype.betTypId == '6') { //if is outright
        dispatchName = 'getSportOutrightOdds'
      }
      if (token_val == '' || token_val == undefined) {
        token_val = token.arr_8
      }
      // this.reloadingPer = '80%';
      this.$store.dispatch(dispatchName, {
        token: token_val,
        scheduleMarket: this.$store.getters.market.inPlayMarket.key,
        showfavorite: (this.$store.getters.showFavEvents && dispatchName == 'getSportOdds')? true:false,
        callback: ((res) => {
          if (res.events) {
            this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
            this.startTimer()
            clearInterval(this.reconnectTimerId)
            this.reconnectTimerId = null
            _.forEach(res.events, function (val, key) {
              // _.forEach(val, function (v, k) {
              //   var showAllBet = $('#moreExpand' + v.eveid).hasClass('icon-moreCollapse')
              //   if (showAllBet) {
              //     $('#moreExpand' + v.eveid).addClass('icon-moreExpand')
              //     $('#moreExpand' + v.eveid).removeClass('icon-moreCollapse')
              //     $('#moreBets' + v.eveid).css("display", "none");
              //   }
              // })
            })
            this.rbtable = true;
          } else {
            this.reconnectTimerSeconds = 5;
            if (this.reconnectTimerId == null) {
              this.reconnectTimerId = setInterval(() => {
                if (this.reconnectTimerSeconds - 1 < 0) {
                  this.reloadRBTable()
                } else {
                  this.reconnectTimerSeconds -= 1;
                }
              }, 1000);
            }
          }
          // if (this.showFavEvents) {
          //   this.$store.dispatch('getLaugueList', (function (res) {
          //     this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
          //     this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
          //   }).bind(this))
          // }
          if(this.$store.getters.selectedMarket == 1 && this.$store.getters.selectedBettype.betTypId != '6' && this.$store.getters.selectedBettype.betTypId != '5'){
            if(this.normaltable == true && this.rbtable == true){
              this.reloading = false 
            this.oddsReload = false
            EventBus.$emit('templateChange', this.oddsReload);
            this.refreshScroll()

            this.$store.commit('PARLAY_SELECTED', { update: false })
            }
          }else{
            this.reloading = false 
            this.oddsReload = false
            EventBus.$emit('templateChange', this.oddsReload);
            this.refreshScroll()

            this.$store.commit('PARLAY_SELECTED', { update: false })
          }
          
          $('#tblRefresh').removeClass('loading-static-animation')
        }).bind(this)
      })
    },
    startTimer() {
      if (this.timerId == null) {
        this.timerId = setInterval(() => {
          if (this.timerSeconds - 1 < 0) {
            
            this.$store.commit('SHOW_UP_DOWN', true)
            // this.reloadTable(token.arr_1)
            this.refreshTbl(token.arr_1)
          } else {
            this.timerSeconds -= 1;
          }
        }, 1000);
      }
    },
    getLeagueList() {
      if (this.$store.getters.int_fullHalfTime == '2') {
        this.$store.commit('SPORT_FULLHALF_TIME', 1)
      }
      //Today RB
      // Prevent InPlay ajx twice
      // need merge rb n normal league
      if (!this.$store.getters.open_RBMarket && this.$store.getters.selectedMarket == this.market.tdyMarket.key 
        && (!this.excludeLge.includes(this.$store.getters.selectedBettype.betTypId) || (this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab))) {
        this.$store.dispatch('getLaugueList', {
          scheduleMarket: this.market.inPlayMarket.key, //RB market
        })
      }

      this.$store.dispatch('getLaugueList', {
        callback: ((res) => {
          if(this.$store.getters.arr_leagueList!=undefined){
            this.$store.commit('SELECTEDLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
            this.$store.commit('TOTALLEAGUES', Object.keys(this.$store.getters.arr_leagueList).length)
          }
          // not parlay/outright
          // if (!this.$store.getters.open_RBMarket && this.$store.getters.selectedMarket == this.market.tdyMarket.key && 
          //   (!this.excludeLge.includes(this.$store.getters.selectedBettype.betTypId) || (this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab))) {
          //   this.reloadRBTable()
          // }
          this.reloadTable()
        }).bind(this)
      })
    },
    clearTimer() {
      clearInterval(this.timerId)
      this.timerId = null
    },
    refreshTimer() {
      this.clearTimer()
      this.timerSeconds = this.getMarketTimer(this.$store.getters.selectedMarket)
      // this.timerSeconds = this.$store.getters.selectedMarket == this.$store.getters.market.inPlayMarket.key ? 30 : 180
      this.startTimer()
    },
    refreshScroll() {
      var main = document.getElementById('right_div');
      var sportTableWidth = $('.tableContent').outerWidth();
      if (main) {
        var maxTop = main.parentNode.parentNode.scrollHeight - main.offsetHeight;

        main.parentNode.parentNode.onscroll = function () {
          main.style.top = Math.min(this.scrollTop + 39) + "px";
          main.style.left = sportTableWidth + "px";
        }
      }
    },
    getSportSettings(token_val = '') {
      // this.reloadingPer = '0%';
      this.reloading = true
      this.maxPayout = false
      this.maxPayout_O = false
      var data = {
        market: this.$store.getters.selectedMarket,
        template: (this.$store.getters.open_RBMarket || this.$store.getters.hotSchedule)? '1':this.$store.getters.selectedBettype.tmpltId,
      }
      if (this.$store.getters.selectedBettype.betTypId == '5') {
        data.sportId = this.$store.getters.selectedBettype.sprtId
      }
      data.token = token_val

      this.$ajax({
        method: 'get',
        url: window._baseUrl + '/sport-settings',
        data: data,
      }).done(((res) => {
        // this.reloadingPer = '50%';
        var sportTableLang = {
          table: window.lang.sportTableLang,
          template_lang: res.data._lang.template_lang
        }
        this.$store.commit('SPORTTABLELANG', sportTableLang)
        this.getLeagueList()
        this.templateClass = 'tableContent common'
        if (this.templateClassArr[this.$store.getters.selectedBettype.tmpltId]) {
          this.templateClass = 'tableContent ' + this.templateClassArr[this.$store.getters.selectedBettype.tmpltId]
        }
        // this.reloadingPer = '75%';
        this.computeSubTitle(res)
        if (this.leagueToggle === true) {
          this.toggleLeague()
        }
      }).bind(this)).catch((errRes) => {
        console.log(errRes)
      })
    },
    showEarlyDateList() {
      var isEarly = this.selectedMarket == this.market.earlyMarket.key ? true : false
      var isParlay = this.selectedBettype.betTypId == '5' ? true : false
      var isOTR = this.selectedBettype.betTypId == '6' ? true : false
      if (this.showFavEvents) {
        return false
      }
      if (!(isEarly && isOTR) && (isEarly || isParlay)) {
        return true
      }

      return false
    },
    computeSubTitle(res) {
      if (this.$store.getters.selectedBettype.tmpltId != '1' &&
        this.$store.getters.selectedBettype.tmpltId != '7' &&
        this.$store.getters.selectedBettype.tmpltId != '8') {
        this.subTitle = ' / ' + this.$store.getters.selectedBettype.betTypLang
      } else if (this.$store.getters.selectedBettype.betTypId == '5' ||
        this.$store.getters.selectedBettype.betTypId == '6') {
        this.subTitle = ' / ' + this.$store.getters.selectedBettype.betTypLang
        if (this.selectedBettype.sprtId == 'N1' && res && res.data.max_payout_setting) {
          this.maxPayout = res.data.max_payout_setting[1]
          this.maxPayout_O = res.data.max_payout_setting[1]
        } else if (this.selectedBettype.sprtId == 'G1' && res && res.data.max_payout_setting) {
          this.maxPayout = res.data.max_payout_setting[2]
          this.maxPayout_O = res.data.max_payout_setting[2]
        }
      } else {
        this.subTitle = ""
      }
    },
    totalCountByDate(date, temp=''){
      let currectSport = this.$store.getters.selectedBettype.sprtId
      let betTypId = this.$store.getters.selectedBettype.betTypId
      let sportId = ''
      let sid = []
      let totalCount = 0
      let allDateCount = this.$store.getters.arr_earlyEventCountByDate
      if(this.$store.getters.selectedBettype.betTypId == '5' && !this.$store.getters.isParlayTab){
        betTypId = this.$store.getters.previousBettype && this.$store.getters.previousBettype.bettype? this.$store.getters.previousBettype.bettype.betTypId:'1'
      }
      if(currectSport.charAt(0) == 'N'){
        let ss = currectSport.replace("N",'');
        sid.push(ss)
      }else if(currectSport == 'G1'){
          sid.push('2','13')
      }else if(currectSport == 'G2'){
          sid.push('7', '14', '19', '20')
      }

      _.forEach(sid, function(sval){
        if(betTypId== 5){
          totalCount = allDateCount['p'+sval] && allDateCount['p'+sval][date] ? allDateCount['p'+sval][date] : 0
        }else{
          if(temp=='all'){
            totalCount = allDateCount[sval] && allDateCount[sval][date] ?  (allDateCount[sval][0] ? allDateCount[sval][date] - allDateCount[sval][0] : allDateCount[sval][date]) : 0
          }else{
            totalCount = allDateCount[sval] && allDateCount[sval][date] ? allDateCount[sval][date] : 0
          }
        }
        
      })

      return totalCount
    },
  },
}

</script>
<style lang="scss">
</style>
<style lang="scss">
// @import "~@/styles/home/main";
// @import "~@/styles/home/sport";
</style>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/sportTable.vue